import {
    defineMessages,
} from 'react-intl'

const messages = defineMessages({
    "most_used_filters": {
        id: "invoice.listing.headers.most_used_filters",
        defaultMessage: "Most used filters",
    },
    "status": {
        id: "invoice.listing.headers.status_label",
        defaultMessage: "Status",
    },
    "status_filter_placeholder": {
        id: 'invoice.listing.status_filter_placeholder',
        defaultMessage: 'Filter by status',
    },
    "sellerId": {
        id: "invoice.listing.headers.seller_id",
        defaultMessage: "User id",
    },
    "title": {
        id: "scheduling_page.events.listing.headers.title_label",
        defaultMessage: "Title",
    },
    "location": {
        id: "invoice.listing.headers.location",
        defaultMessage: "Location",
    },
    "calendar": {
        id: "common.scheduling_page.modal.calendar_label",
        defaultMessage: 'Calendar'
    },
    "identifier": {
        id: "invoice.listing.headers.id_label",
        defaultMessage: 'ID'
    },
    "start_at": {
        id: 'scheduling_page.events.listing.headers.start_at_label',
        defaultMessage: 'Start at',
    },
    "end_at": {
        id: "scheduling_page.events.listing.headers.end_at_label",
        defaultMessage: "End at",
    },
    "date_related_filters": {
        id: "invoice.listing.headers.date_related_filters",
        defaultMessage: "Date related filters",
    },
    "other_filters": {
        id: "invoice.listing.headers.other_filters",
        defaultMessage: "Other filters",
    },
    "contact_nameSort": {
        id: "invoice.listing.headers.contact_nameSort",
        defaultMessage: "Contact",
    },
    "contact_organization_name": {
        id: "invoice.listing.headers.contact_organization_name",
        defaultMessage: "Contact organization name",
    },
    "contact_type": {
        id: "invoice.listing.headers.contact_type",
        defaultMessage: "Contact type",
    },
    "contact_name": {
        id: "invoice.listing.headers.contact_name",
        defaultMessage: "Contact name",
    },
    "contact_id": {
        id: "invoice.listing.headers.contact_id",
        defaultMessage: "Contact id",
    },
    "project_id": {
        id: "invoice.listing.headers.project_id",
        defaultMessage: "Contact organization name",
    },
    "contact_related_filters": {
        id: "invoice.listing.headers.contact_related_filters",
        defaultMessage: "Contact related filters",
    },
})

export const calendarEventListTotals = []

export const calendarEventFields = [
    'identifier',
    'title',
    'titleKeyword',
    'titleAnalyzed',
]

export const getCalendarEventFilters = function (context) {
    var filtersToUse =
        [
            {
                section: context.intl.formatMessage(messages["most_used_filters"]),
            },
            {
                nameId: 'userId',
                label: context.intl.formatMessage(messages["sellerId"]),
                filterMatch: 'userId',
                type: 'select',
                typeOfSelect: 'user-select',
                placeHolder: 'Select User',
                initialValue: '',
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'locationNameSort',
                label: context.intl.formatMessage(messages["location"]),
                filterMatch: 'locationNameSort',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: "title",
                label: context.intl.formatMessage(messages["title"]),
                filterMatch: 'titleKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'statuses',
                label: context.intl.formatMessage(messages["status"]),
                type: 'select',
                filterMatch: 'status',
                typeOfSelect: 'calendar-event-status-select',
                placeHolder: context.intl.formatMessage(messages["status_filter_placeholder"]),
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'calendarId',
                label: context.intl.formatMessage(messages["calendar"]),
                filterMatch: 'calendarId',
                type: 'select',
                typeOfSelect: 'calendar-select',
                placeHolder: 'Select Calendar',
                initialValue: '',
                initialSelect: 'isOneOf'
            },
            {
                section: context.intl.formatMessage(messages["date_related_filters"]),
            },
            {
                nameId: 'startAt',
                label: context.intl.formatMessage(messages["start_at"]),
                filterMatch: 'startAt',
                type: 'date',
                initialValue: { startDate: null, endDate: null },
                initialSelect: 'is'
            },
            {
                nameId: 'endAt',
                label: context.intl.formatMessage(messages["end_at"]),
                filterMatch: 'endAt',
                type: 'date',
                initialValue: { startDate: null, endDate: null },
                initialSelect: 'is'
            },
            {
                section: context.intl.formatMessage(messages["contact_related_filters"]),
            }, {
                nameId: 'contactId',
                label: context.intl.formatMessage(messages["contact_id"]),
                filterMatch: 'contactId',
                type: 'select',
                typeOfSelect: 'customer-select',
                initialValue: "",
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'name',
                label: context.intl.formatMessage(messages["contact_name"]),
                filterMatch: 'contact.name',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'organizationName',
                label: context.intl.formatMessage(messages["contact_organization_name"]),
                filterMatch: 'contact.organizationNameKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'contactType',
                label: context.intl.formatMessage(messages["contact_type"]),
                filterMatch: 'contact.type',
                type: 'select',
                typeOfSelect: 'contactType-select',
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                section: context.intl.formatMessage(messages["other_filters"]),
            },
            {
                nameId: "identifier",
                label: context.intl.formatMessage(messages["identifier"]),
                filterMatch: 'identifier',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
        ]

    return filtersToUse
}


// WEBPACK FOOTER //
// ./src/common/search-filter/search/calendarEventFilters.jsx